import { instance, errorService, dateComparator } from '@/services/api'
import { dropdownAPIs, templateAPIs } from '@/services/authConstantsV1'
import {
  calculateGridHeight,
  customComparator,
  showNotification,
} from '@/services/calculate'
import { socketEvents, tableName } from '@/services/config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import AddNewTemplate from '../AddNewTemplate'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import DatePickerFilter from '@/components/DynamicComponents/Renderers/datePickerFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import SelectEditor from '@/components/DynamicComponents/Renderers/dropdownEditor'
import 'ag-grid-enterprise'

export default {
  components: {
    AddNewTemplate,
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  data() {
    return {
      templateData: [],
      page: 0,
      totalCount: 0,
      addTemplate: false,
      loading: false,
      visible: false,
      sorterOrder: 'updatedDate',
      rowClick: true,
      pageSize: 0,
      loadRefresh: false,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '440px',
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      cloneTemplateData: null,
      dropdownData: [],
      type: 'Create New',
      isAscending: false,
      filters: {},
      selectedRowKeys: [],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 30,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        suppressContextMenu: true,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          menuTabs: ['filterMenuTab'],
        },
      },
      columnDefs: [],
      isLoad: true,
      getDataPath: null,
      autoGroupColumnDef: {},
      settings: JSON.parse(localStorage.getItem('userSettings')) || {},
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  beforeDestroy() {
    this.$root.$off('templatesChange', this.performAction)
    this.$root.$off('updateTemplateBuildingUse', this.updateTemplate)

    window.removeEventListener('resize', this.getWindowSize)
    this.$socketHub.$off('message-received')
  },
  mounted() {
    this.$root.$on('templatesChange', this.performAction)
    this.$root.$on('updateTemplateBuildingUse', this.updateTemplate)

    window.addEventListener('resize', this.getWindowSize)
    this.$socketHub.$on('message-received', this.messageReceived)
    this.loadDropdown()
  },
  methods: {
    performAction(data, status, flag, operation) {
      if (flag) {
        switch (operation) {
          case 'clone':
            this.cloneTemplate(data)
            break
          case 'publish':
            this.publishTemplate(data, status)
            break
          case 'delete':
            this.deleteTemplate(data)
            break
          case 'spin':
            this.loading = flag
            break
          default:
            break
        }
      } else {
        this.loading = flag
      }
    },

    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        customFilter: CustomFilter,
        datePickerFilter: DatePickerFilter,
        toolTipRenderer: ToolTipRenderer,
        selectEditor: SelectEditor,
      }

      this.autoGroupColumnDef = {
        headerName: 'Template Name',
        colId: 'templateName',
        field: 'templateName',
        width: 355,
        maxWidth: 355,
        flex: 1,
        filter: 'customFilter',
        headerTooltip: 'Template Name',
        resizable: true,
        tooltipField: 'templateName',
        lockPosition: true,
        cellRendererParams: { filter: 'dynamic', suppressCount: true },
      }

      this.getDataPath = data => {
        return data.path
      }
    },

    loadColumns() {
      this.columnDefs = [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 10,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'Template Name',
          colId: 'templateName',
          field: 'templateName',
          width: 355,
          maxWidth: 355,
          flex: 1,
          filter: 'customFilter',
          headerTooltip: 'Template Name',
          resizable: true,
          tooltipField: 'templateName',
          pinned: 'left',
          cellRendererParams: { filter: 'dynamic' },
          hide: true,
        },
        {
          headerName: 'Version',
          field: 'version',
          width: 100,
          headerTooltip: 'Version',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Analysis Type',
          field: 'analysisType',
          width: 150,
          filter: 'customFilter',
          headerTooltip: 'Analysis Type',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          resizable: true,
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Structural Profile',
          field: 'structureProfile',
          width: 200,
          filter: 'customFilter',
          headerTooltip: 'Structural Profile',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Building Use',
          field: 'buildingUse',
          width: 200,
          filter: 'customFilter',
          headerTooltip: 'Building Use',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'template',
            dropdownName: 'templateBuildingUse',
            dropdownData: this.dropdownData,
            filter: 'dynamic',
          },
          editable: true,
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 75,
          headerTooltip: 'Status',
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Created Date',
          field: 'createdDate',
          filter: 'datePickerFilter',
          resizable: true,
          width: 150,
          comparator: dateComparator,
          headerTooltip: 'Created Date',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: { filter: 'dynamic', name: 'createdDate' },
        },
        {
          headerName: 'Created By',
          field: 'createdBy',
          resizable: true,
          width: 180,
          filter: 'customFilter',
          headerTooltip: 'Created By',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Updated Date',
          field: 'updatedDate',
          filter: 'datePickerFilter',
          resizable: true,
          width: 150,
          comparator: dateComparator,
          headerTooltip: 'Updated Date',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic', name: 'updatedDate' },
          suppressSizeToFit: true,
          sort: 'desc',
        },
        {
          headerName: 'Updated By',
          field: 'updatedBy',
          width: 180,
          headerTooltip: 'Updated By',
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 120,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'template',
          },
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    handleOk() {
      this.visible = false
      this.rowClick = true
    },

    handleGridReady(params) {
      this.getTemplates(params)
    },

    getTemplates(params) {
      if (params) {
        params.api.sizeColumnsToFit()
        if (this.isLoad) {
          this.checkPreference()
        }
      }
      this.loading = true
      const request = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.sorterOrder,
        isAscending: this.isAscending,
      }
      const merged = { ...request, ...this.filters }
      instance
        .post(templateAPIs.template.getTemplates, merged)
        .then(response => {
          this.totalCount = _.get(response.data, 'totalCount', 0)
          const tabledata = _.get(response.data, 'result', []).map(
            (data, index) => {
              data['key'] = index + 1
              data['items'] = []
              return data
            },
          )
          this.templateData = this.groupTemplatesByLatestVersionAndStatus(
            tabledata,
          )
          this.height = calculateGridHeight(
            'templateTable',
            this.totalCount > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Function for cancel dialog
    handleCancel() {
      this.visible = false
      this.rowClick = true
    },

    // Function for clone template
    cloneTemplate(data) {
      this.addTemplate = true
      this.rowClick = false
      this.cloneTemplateData = data
      this.type = 'Clone'
    },

    // Function for delete template
    deleteTemplate(data) {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete '${data.templateName}' ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this template.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() {},
      })
    },

    // Function for add new template
    addNewTemplate() {
      this.cloneTemplateData = null
      this.addTemplate = true
      this.rowClick = false
      this.type = 'Create New'
    },

    // PublishTemplate
    publishTemplate(data, status) {
      const that = this
      this.$confirm({
        title: `Are you sure want to ${
          data.status === 'Design' ? 'publish' : 'unpublish'
        } template '${data.templateName}' ?`,
        onOk() {
          that.publish(data, status, 'status')
        },
        onCancel() {},
      })
    },

    updateTemplate(data, value) {
      const req = {}
      req['buildingUseId'] = value
      this.loading = true
      instance
        .patch(`${templateAPIs.template.updateTemplate(data.id)}`, req)
        .then(response => {
          this.loading = true
          this.getTemplates(this.gridOptions)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    publish(data) {
      this.loading = true
      instance
        .patch(`${templateAPIs.template.publishTemplate(data.id)}`)
        .then(response => {
          this.loading = true
          showNotification(
            'success',
            `${data.status === 'Design' ? 'Publish' : 'unpublish'} Template`,
            `Template ${
              data.status === 'Design' ? 'publish' : 'unpublish'
            }  successfully!`,
          )
          this.loading = true
          this.getTemplates(this.gridOptions)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    // Function for load template list data
    refreshTemplate() {
      this.loading = true
      this.loadRefresh = true
      this.sorterOrder = 'updatedDate'
      this.isAscending = false
      this.page = 0
      this.templateData = []
      this.selectedRowKeys = []
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'updatedDate',
            sort: 'desc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getTemplates(this.tableParams)
    },

    // addTemplate pop up handling
    closeCreatePopup(value, isClone) {
      this.addTemplate = value
      if (
        (this.type =
          'Clone' && isClone && this.cloneTemplateData.status === 'Live')
      ) {
        this.getTemplates(this.gridOptions)
      }
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId === 'ag-Grid-AutoColumn' ? 'templateName' : s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.templateData = []
      if (sortData.length > 0) {
        this.sorterOrder = sortData[0]['colId']
        this.isAscending = sortData[0]['sort'] === 'asc'
      } else {
        this.sorterOrder = 'updatedDate'
        this.isAscending = false
      }
      this.getTemplates(this.tableParams)
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'templateTable',
        this.totalCount > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    loadDropdown() {
      const postData = { analysis_type: 1, Structure_Profile: 0 }
      instance
        .post(dropdownAPIs.dropdown, postData)
        .then(response => {
          this.dropdownData = _.get(response.data, 'result', [])
          if (this.dropdownData.analysis_type) {
            this.dropdownData.analysis_type = this.dropdownData.analysis_type.filter(
              i => i.id === 1,
            )
          }
          Object.assign(this.dropdownData, { temp_building_use: [] })
          Object.assign(this.dropdownData, { building_use: [] })
          this.dropdownData['structure_profile'].forEach(element => {
            this.getBuildingUse(element.id)
          })
          this.loadColumns()
        })
        .catch(error => {
          errorService(error)
          this.loadColumns()
        })
    },

    getBuildingUse(value) {
      instance
        .post(dropdownAPIs.dropdown, { building_use: value })
        .then(response => {
          const result = _.get(response.data.result, 'building_use', [])
          result.forEach(element => {
            this.dropdownData['temp_building_use'].push({
              id: element.id,
              option: element.option,
              value: element.value,
              structureProfileId: value,
            })
          })
        })
        .catch(error => {
          errorService(error)
        })
    },

    // Socket listen
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.templateClone) {
        if (data.Status === 'SUCCESS') {
          if (this.cloneTemplateData.status === 'Design') {
            this.getTemplates(this.gridOptions)
          }
        } else {
          this.$notification.error({
            message: 'Clone Template',
            description: h => (
              <div>
                <div>Error occurred while cloning template</div>
              </div>
            ),
            duration: 200,
          })
        }
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
      }
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.templateData = []
      this.selectedRowKeys = []
      this.getTemplates(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      this.templateData = []
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        if (Object.values(data)[index]['filter'] !== '') {
          const field =
            element === 'ag-Grid-AutoColumn' ? 'templateName' : element
          this.filters[field] = Object.values(data)[index]['filter']
        }
      })
      this.page = 0
      this.getTemplates(this.tableParams)
    },

    // Delete Selected Templates
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected templates ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              templates
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(`${templateAPIs.template.deleteTemplate}`, { data: req })
        .then(response => {
          this.loading = true
          showNotification(
            'success',
            'Delete Template',
            'Template deleted successfully!',
          )
          this.refreshTemplate()
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    async checkPreference() {
      this.isLoad = false
      const preference = await this.getColumnSettings()
      if (preference && preference.length > 0) {
        preference.forEach(element => {
          if (element.colId !== 'action') {
            if (element.sort) {
              this.sorterOrder = element.colId
              this.isAscending = element.sort === 'asc'
            }
          } else if (element.colId === 'action') {
            element.pinned = 'right'
            element.suppressMovable = true
          }
        })
        this.gridOptions.columnApi.applyColumnState({
          state: preference,
          applyOrder: true,
        })
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    getColumnSettings(params) {
      return instance
        .get(templateAPIs.columns.list)
        .then(response => {
          const details = _.get(response.data, 'result', null)
          return details && details.columnDetails
            ? JSON.parse(details.columnDetails)
            : details
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        if (e.source !== 'sizeColumnsToFit' && e.source !== 'api') {
          this.updateColumns()
        }
      }
    },

    updateColumns() {
      instance
        .put(templateAPIs.columns.update, {
          tableName: tableName.templateDashboard,
          columnDetails: JSON.stringify(this.tableState),
        })
        .then(response => {})
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    groupTemplatesByLatestVersionAndStatus(data) {
      // 1️⃣ Group by templateName + status
      const grouped = {}
      // 2️⃣ Build tree data with path
      const result = []

      data.forEach(item => {
        const key = `${item.templateName}`

        if (!grouped[key]) {
          grouped[key] = []
        }

        grouped[key].push(item)
      })

      // 2️⃣ Build final array
      Object.values(grouped).map(items => {
        // sort by version DESC
        items.sort((a, b) => b.version - a.version)

        const [latest, ...rest] = items

        const parentPath = [`${latest.templateName}`]

        // Parent row
        result.push({
          ...latest,
          path: parentPath,
        })

        // Child rows
        rest.forEach(child => {
          result.push({
            ...child,
            path: [...parentPath, `v${child.version}`],
          })
        })
      })

      return result
    },

    getTemplateName(name) {
      return `
      <div>
        <a-tooltip placement="right" :title="${name}"> ${name} </a-tooltip>
      </div>
      `
    },
  },
}
